module.exports = __webpack_public_path__ + "img/disableblueedit.b9adcec4.svg";